import { Typography } from '@vp/swan'

interface SetChipProps {
  setName: string
  color: string
}

export const SetChip = ({ setName, color }: SetChipProps) => (
  <div className="set-chip" style={{ backgroundColor: color }}>
    <Typography fontSize="standard" fontWeight="bold">
      {setName}
    </Typography>
  </div>
)
